<template>
    <div class="" v-loader.opacity.tab="loading">
      <div class="clinic-template-list" id="consent-template-list" v-if="!isEditTemplate">
        <BaseTable class="no-border" v-if="tableTemplates" :tabledata="tableTemplates" @item-opened="toDetails"/>
  
        <button class="btn-icon btn-top" type="button" name="button" v-if="tableTemplates && tableTemplates.items.length > 20" @click="goTop">
          <IconArrowUp/>
        </button>
      </div>
  
      <div class="clinic-edit-box" v-else>
        <ClinicConsentTemplateEdit :template_id="template ? template.id : null" @cancel-edit="cancelEditTemplate"></ClinicConsentTemplateEdit>
      </div>
  
      <!-- TODO: I'll return in a second stage -->
      <!-- <div class="action-bar" v-if="!isEditTemplate">
        <button class="btn btn-success" type="button" name="button" @click="isEditTemplate = !isEditTemplate">
          <span>{{ $t('clinic.newConsentTemplate') }}</span>
        </button>
      </div> -->
    </div>
  </template>
  
  <style lang="scss" scoped>
  .clinic-template-list {
    padding:                          0 10px 10px 10px;
    overflow-y:                       auto;
    flex:                             1;
  }
  
  @media (max-width: 991px) {
    .clinic-template-list {
      height:                         calc(100dvh - 258px);
      max-height:                     calc(100dvh - 258px);
      padding:                        0;
    }
  
    .has-alert {
      .clinic-template-list {
        height:                       calc(100dvh - 336px);
        max-height:                   calc(100dvh - 336px);
      }
    }
  
    .has-usage-bar {
      .clinic-template-list {
        height:                       calc(100dvh - 286px);
        max-height:                   calc(100dvh - 286px);
      }
    }
  }
  
  @media screen and (min-width: 992px) and (max-width: 1365px) {
    .clinic-template-list {
      height:                         calc(100dvh - 309px);
    }
  
    .has-alert {
      .clinic-template-list {
        height:                       calc(100dvh - 373px);
        max-height:                   calc(100dvh - 373px);
      }
    }
  }
  </style>
  
  <script>
  import { useUserStore } from '@/store/user'
  import ClinicConsentTemplateEdit from './ClinicConsentTemplateEdit.vue'
  
  export default {
    name: 'ClinicConsentTemplateTab',
    components: {
      ClinicConsentTemplateEdit,
    },
    data: () => ({
      loading: false,
      tableTemplates: null,
      isEditTemplate: false,
      template: null,
      session: {}
    }),
    mounted: function() {
      const userStore = useUserStore();
      this.session = userStore.sessionInfo;

      this.fetchData();
    },
    methods: {
      goTop() {
        const el = document.getElementById('consent-template-list')
        if (el) el.scrollTop = 0
      },
      async fetchData() {
        this.loading = true
        NProgress.start()
        try {
          let response = await this.$clinicService.listConsentTemplates({
            clinicID: this.session.currentClinic.id,
          });
  
          this.tableTemplates = {
            'items': response.result,
            'columns': [
              {name: this.$i18n.t('name'), type: 'string', value: 'name', width: '35%'},
              {name: this.$i18n.t('description'), type: 'string', value: 'description', width: '65%'},
            ]
          }
        } catch (err) {
          this.$message.popup(this, 'request_error', 'operationFail', 'error')
        }
        NProgress.done(true)
        this.loading = false
      },
      toDetails(values) {
        if (!values || !values.item) return
        this.template = values.item;
        this.isEditTemplate = true;
      },
      cancelEditTemplate() {
        this.template = null
        this.isEditTemplate = false;
        this.fetchData();
      }
    }
  }
  </script>